import crudActions from '../../crud/actions'

const actions = crudActions('SETTINGS_LISTS_HYDRATION_')

export default actions
